export default __webpack_public_path__ + "static/media/broken-page.980a491c.svg";